import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('lh_theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('lh_theme', theme);

    if (window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform()) {
      import('@capacitor/status-bar')
        .then(({ StatusBar, Style }) => {
          StatusBar.setStyle({
            style: theme === 'dark' ? Style.Dark : Style.Light
          }).catch(err => console.error("Capacitor StatusBar setStyle error", err));
        })
        .catch(err => console.error("Failed to load Capacitor StatusBar", err));
    }
  }, [theme]);

  function toggle() { setTheme(t => t === 'dark' ? 'light' : 'dark'); }

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() { return useContext(ThemeContext); }
